import React from 'react';

interface Props {
    name?: string;
    value: string | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onclick?: () => void;
    isCustomStyle: boolean;
    type?: string;
    required?: boolean;
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    customCss?: string;
    max?: number;
    min?: number;
    step?: number;
    inputMode?: "text" | "email" | "search" | "none" | "tel" | "url" | "numeric" | "decimal" | undefined;
    onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    readonly?: boolean;
}

export default function Input({ readonly, onclick, onBlur, isCustomStyle, name, value, type = "text", required, placeholder, onChange, maxLength, disabled, customCss = '', max, min, step, inputMode }: Props) {
    const baseStyle = 'rounded-md border block w-full text-xs px-3 py-2 outline-none placeholder:text-gray-400 transition-colors';

    const defaultInputStyle = `${baseStyle} border-gray-300 focus:border-[#186cb2] focus:ring-1 focus:ring-[#186cb2]/20`;

    return (
        <input 
            aria-readonly={readonly}
            onClick={onclick} 
            autoComplete="" 
            inputMode={inputMode} 
            step={step} 
            max={max} 
            min={min} 
            name={name} 
            type={type} 
            value={value} 
            onChange={onChange} 
            readOnly={!onChange} 
            className={`${isCustomStyle ? customCss : defaultInputStyle} ${disabled ? 'cursor-not-allowed bg-gray-100' : ''}`} 
            placeholder={placeholder} 
            required={required} 
            maxLength={maxLength} 
            disabled={disabled} 
            onBlur={onBlur} 
        />
    );
}